import React, { useState } from 'react';
import PropTypes from 'prop-types';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};

function MultiSelect({ title, data, callBack, selectedValue, disabled, error }) {
	// const classes = useStyles()
	const [selectedItems, setSelectedItems] = useState(
		!selectedValue || !selectedValue[0] ? [] : selectedValue
	);

	const handleChange = (e) => {
		e.stopPropagation();
		const { value } = e.target;
		setSelectedItems(value);
		callBack(e, value);
	};

	return (
		<div>
			<FormControl
				fullWidth
				variant="outlined"
			>
				<InputLabel id="demo-mutiple-checkbox-label">{title}</InputLabel>
				<Select
					labelId="demo-mutiple-checkbox-label"
					id="demo-mutiple-checkbox"
					multiple
					value={selectedItems}
					onChange={(e) => handleChange(e)}
					renderValue={(selected) => selected.join(', ')}
					MenuProps={MenuProps}
					disabled={disabled}
					error={error}
				>
					{data.map((item) => (
						<MenuItem
							key={item}
							value={item}
						>
							<Checkbox checked={selectedValue && selectedItems.indexOf(item) > -1} />
							<ListItemText primary={item} />
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
}

MultiSelect.propTypes = {
	title: PropTypes.string,
	data: PropTypes.array,
	callBack: PropTypes.func,
	selectedValue: PropTypes.array,
	disabled: PropTypes.bool,
	error: PropTypes.bool
};

export default MultiSelect;
